import { useContext } from 'react';
import { nodeEq } from './utils';

import { SelectedItemsContext, GridCellContext } from './Contexts';

export default function useIsNodeSelected(nodeId){

  const selectedItems = useContext(SelectedItemsContext);
  let cellLocation = useContext(GridCellContext);

  let thisNode = { cellLocation, nodeId };


  let selected;
  try{
    selected = selectedItems?.expansionNodes?.find((item) => nodeEq(item, thisNode))
  }catch(e){
    debugger;
  }

  return selected;

}
